import { DotLottieReact } from "@lottiefiles/dotlottie-react";
// import NoDataHere from "../Img/nodatahere.png";

// export const DataNotFound = ({msg}) => {
//   return (
//     <div
//       className="hstack justify-content-center align-items-center"
//       style={{ height: "-webkit-fill-available" }}
//     >
//       <div className="text-center" style={{ pointerEvents: "none", userSelect: "none" }}>
//         <img src={NoDataHere} style={{ width: 200, opacity: .1 }} alt="" />
//         <p className="text-muted small m-0">{msg}</p>
//       </div>
//     </div>
//   );
// };

export const EarthLoader = () => {
  return (
    <div
      className="hstack justify-content-center align-items-center"
      style={{ height: "-webkit-fill-available" }}
    >
      <DotLottieReact
        src="https://lottie.host/4fa5ea23-8f4c-4f77-952c-ac99126d75b9/hDLrceY0qx.lottie"
        loop
        autoplay
        style={{ width: 500, height: 250 }}
      />
    </div>
  );
};

export const PageLoader = () => {
  return (
    <div
      className="hstack justify-content-center align-items-center"
      style={{ height: "-webkit-fill-available" }}
    >
      <DotLottieReact
        src="https://lottie.host/85c4f7e0-d0ee-4a11-b2fe-2fe2d03f6b6e/68Cx71lG5s.lottie"
        loop
        autoplay
        style={{ width: 500, height: 250 }}
      />
    </div>
  );
};